import { Body, Button } from '@e2n/ui/v2';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import { useDatevAuthContext } from '../../lib/DatevAuthContext';

export function Authorized() {
  const { t } = useTranslation();
  const { status, logout } = useDatevAuthContext();
  return (
    <div className="flex items-center gap-4">
      <div className="size-12 bg-neutrals-v2-200 rounded-xl flex items-center justify-center">
        <FontAwesomeIcon
          icon={faCircleCheck}
          className="text-accent-green-100 size-6"
        />
      </div>
      <div className="flex flex-col gap-1">
        <Body weight={'semibold'}>
          {t('domain.datev.page.connection.status.connected.text')}
        </Body>
        <div className="flex flex-col">
          <Body size={'sm'} className="text-labels-secondary">
            {t('domain.datev.page.connection.status.connected.beraterMandant', {
              beraternummer: status?.beraternummer,
              mandantennummer: status?.mandantennummer,
            })}
          </Body>
          <Body size={'sm'} className="text-labels-secondary">
            {t('domain.datev.page.connection.status.connected.token', {
              date: dayjs(status?.expiresAt).format('DD.MM.YYYY, HH:mm'),
            })}
          </Body>
        </div>
      </div>
      <Button variant={'outline'} className="ml-auto" onClick={logout}>
        {t('domain.datev.page.connection.status.logout')}
      </Button>
    </div>
  );
}
